import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { Programa } from '../models/programa.model';

@Injectable({
  providedIn: 'root'
})
export class ProgramaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all programas
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: Programa[] }>(`${this.path}/getAllPrograma`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      // debounceTime(500),
      map(response => response)
    );
  }

  // Get programa by ID
  public show(id: string): Observable<Programa> {
    return this.apiService.get<{ data: Programa, retorno: any }>(`${this.path}/getProgramaById/${id}`).pipe(
      map(response => response.data as Programa)
    );
  }

  // Create new programa
  public store(programa: Programa): Observable<Programa> {
    return this.apiService
      .post<{ object: Programa }>(`${this.path}/AddPrograma`, programa)
      .pipe(
        map((response) => response.object as Programa)
      );
  }

  // Update existing programa
  public update(programa: Programa, id: string): Observable<Programa> {
    return this.apiService
      .put<{ object: Programa }>(`${this.path}/UpdatePrograma/${id}`, programa)
      .pipe(
        map((response) => response.object as Programa)
      );
  }

  // Delete existing programa
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteProgramaById/${id}`);
  }
}
